module.exports = __webpack_public_path__ + "static/lidka-12bc3ec9e678643cd7d839f4c1df1338.jpg";